import { RelationshipCoreBase } from "./relationship.core.base"


export class RelationshipCore extends RelationshipCoreBase {

}